export const ActionTypes = {
    SetState: "SetState",
    ClearState: "ClearState",
    UpdateFieldsValue: "UpdateFieldsValue",
};
